import gql from 'graphql-tag';
import client from '../../client';
import { INVENTORY_FIELDS } from '../fragments/inventoryFields';
import { PRODUCT_FIELDS } from '../fragments/productFields';
export const FORCE_CANCEL_MEMBERSHIP = gql `
  ${INVENTORY_FIELDS}
  ${PRODUCT_FIELDS}

  mutation membership($input: MembershipInput!) {
    forceCancelMembership(input: $input) @rest(type: "CancelMembershipResult", path: "admin/orders/forced-cancel", method: "POST") {
      data @type(name: "Membership") {
        id
        user
        payment
        paymentMethod
        state
        reason
        products @type(name: "Product") {
          ...ProductFields
          inventory @type(name: "Inventory") {
            ...InventoryFields
          }
        }
        createdAt
        updatedAt
        completedAt
      }
    }
  }
`;
// Mutation to force cancel a membership
export const forceCancelMembership = (membershipId, orderId, userId) => {
    return client.mutate({
        mutation: FORCE_CANCEL_MEMBERSHIP,
        variables: {
            input: {
                userId,
                data: {
                    membershipId,
                    orderId,
                },
            },
        },
    });
};
export default forceCancelMembership;
